import declare from "dojo/_base/declare";
import _ from "underscore";
import TypeSwitchboardTable from "csi/table/TypeSwitchboardTable";

function setColumns(defView: any, containerTargetType: string): void {
	defView.m_headings = [
		_.extend(defView.newHeading(), { m_id: containerTargetType + ".Default", m_bCard: true }),
		_.extend(defView.newHeading(), { m_id: "CntDocuments" }),
	];
}

const DGaaSTemplateOwnerTable = declare(TypeSwitchboardTable, {
	/**
	 * @override
	 * Show all the nodes based on DGaaSTemplate.PrimaryType
	 */
	_resolveView() {
		let dGaaSOwner = this.getViewNode();
		if (dGaaSOwner && dGaaSOwner.$Type !== "DocumentGroup") {
			if (dGaaSOwner.$Type === "DGaaSTemplateRevision") {
				dGaaSOwner = this.cacheView.get(dGaaSOwner.Master);
			}
			const primaryType = dGaaSOwner?.PrimaryType;
			this.set("containerSourceType", primaryType);
			// initialize the list of columns based on node type
			setColumns(this.defView, this.containerSourceType);
		}
		this.inherited(arguments);
	},
});

export default DGaaSTemplateOwnerTable;
